export const isTopArrowIsNotVisible = (index: number) => {
  return index === 0
}
